import { PRODUCT_DOMAIN } from "@/constants";

const productDomainMap: Record<string, string> = {
  IRE: "ireland",
  EXP: "expat",
  STS: "staysure",
  AVN: "avanti",
  ESP: "spain",
};

export const getBrandDomain = (): string => {
  return productDomainMap[PRODUCT_DOMAIN] ?? "staysure";
};
